import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { Formation } from "types";
import type { RootState } from "../store";

// Define a type for the slice state
interface FormationsState {
  formations: Formation[];
  loading: boolean;
}

// Define the initial state using that type
const initialState: FormationsState = {
  formations: [],
  loading: false,
};

export const formationsSlice = createSlice({
  name: "formations",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setFormations: (state, action: PayloadAction<Formation[]>) => {
      state.formations = action.payload;
    },
    setLoadingFormations: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
  },
});

export const { setFormations, setLoadingFormations } = formationsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getFormations = (state: RootState) => state.formations;
export default formationsSlice.reducer;
